import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import { NamedLink } from '../../components';
import handIcon from './handIcon.png';
import css from './SectionNeedParking.module.css';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import hourGlassIcon from './hourGlassIcon.png';
import mapPinIcon from './mapPinIcon.png';
import pic1 from './pic1.png';
import pic2 from './pic2.png';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const SectionNeedParking = props => {
  const { rootClassName, className, history, isMobile } = props;

  const accordeonClasses = useStyles();

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      {/* <div className={css.title}>
        <FormattedMessage id="SectionHowItWorks.titleLineOne" />
        <br />
        <FormattedMessage id="SectionHowItWorks.titleLineTwo" />
      </div> */}
      <div className={css.sectionLeft}>
      {/* <FormattedMessage id="SectionNeedParking.leftWriting" /> */}
      {isMobile ? 
        <span className={css.sectionLeftTitle}>Avec ollo, se garer <br/> chez un particulier devient<br/> <strong className={css.boldText}>possible & facile !</strong></span>
            :
        <span className={css.sectionLeftTitle}>Avec ollo,<br/> se garer chez un particulier devient <strong className={css.boldText}>possible & facile !</strong></span>

      }
      </div>

      <div className={css.sectionRight}>

        <div className={css.buttonsWrapper}>

            <div className={css.sectionRightButton}> 
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={css.roundButton}
              >
                <Typography className={accordeonClasses.heading}>
                  <h2 className={css.questionStyle}>
                  <img className={css.iconPic} src={pic2}/> J’ai besoin d’une place 
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                    <div className={css.accordeonContent}>  
                        <h2 className={css.questionStyle}>Pourquoi réserver un ollo si vous voulez vous garer ?</h2>
                        <ul>
                          <li>
                            👉<span className={css.accordeonItemLabel}>Les locations sont flexibles </span>
                             <p>
                             Que ce soit pour quelques jours ou plusieurs mois, nos hôtes partenaires seront ravis de vous proposer leur place.
                            </p>
                          </li>

                          <li>
                            👉<span className={css.accordeonItemLabel}>Les prix sont justes</span>
                             <p>
                             Chez ollo, les prix sont dégressifs dès 3 jours de location. Cherchez moins cher, vous ne trouverez pas !
                            </p>
                          </li>

                          <li>
                            👉<span className={css.accordeonItemLabel}>Le service est sécurisé </span>
                             <p>
                             Votre voiture, scooter ou vélo sera au chaud ! Toutes nos places se situent en parkings résidentiels sécurisés 
                            </p>
                          </li>
                      

                        {/* <li>
                            👉<span className={css.accordeonItemLabel}>De plus, toutes les locations sont couvertes par notre partenaire Allianz !</span>
                            
                          </li> */}

                          <li className={css.buttonWrapper}>
                            <button onClick={() => history.push('/s')}>Trouver la place idéale</button>
                          </li>
                        </ul>

                    </div>
              
              </AccordionDetails>
            </Accordion>
            
            </div>





            <div className={css.sectionRightButton} >
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={accordeonClasses.heading}>
                  <h2 className={css.questionStyle}>
                  
                  <img className={css.iconPic} src={pic1}/> Je souhaite louer ma place 
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                    <div className={css.accordeonContent}>  
                        <h2 className={css.questionStyle}>Pourquoi publier mon annonce sur ollo?</h2>
                        <ul>
                          <li>
                            👉<span className={css.accordeonItemLabel}>Les revenus locatifs sont plus élevés</span>
                             <p>
                             Optez pour de la location courte durée et générez un meilleur rendement 
                            </p>
                          </li>

                          <li>
                            👉<span className={css.accordeonItemLabel}>La gestion est déléguée</span>
                             <p>
                             Ollo s’occupe de la remise des accès et vous propose de suivre les performances de votre parking directement via votre espace
                            </p>
                          </li>

                          <li>
                            <span className={css.accordeonItemLabel}>👉 La sécurité est garantie </span>
                             <p>
                             Les paiements sont sécurisés, et les contrats de locations dématérialisés
                            </p>
                          </li>
                      

                        {/* <li>
                            👉<span className={css.accordeonItemLabel}>La remise des accès simplifiée !</span>
                            
                          </li>
                        </ul> */}

                        <li className={css.buttonWrapper}>
                            <button onClick={() => history.push('/l/draft/00000000-0000-0000-0000-000000000000/new/location')}>Louez facilement votre place</button>
                          </li>

                          </ul>

                    </div>
              
              </AccordionDetails>
            </Accordion>
                
            </div>

        </div>
      </div>

    </div>
  );
};

SectionNeedParking.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionNeedParking.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionNeedParking;
